import axios from "axios";
import {
  CommunicationChannel,
  CommunicationsListResponse,
  CustomerCommunicationDetail,
  StatusFilter,
} from "./types";

const baseUrl = (customerId: string) =>
  `${process.env.REACT_APP_SERVER_URL}/api/v2/company/customers/${customerId}/communications`;

export const getCustomerCommunications = async (
  customerId: string,
  params: {
    channel: CommunicationChannel;
    page?: number;
    limit?: number;
    status?: StatusFilter;
  }
): Promise<CommunicationsListResponse> => {
  const response = await axios.get(baseUrl(customerId), {
    params: {
      channel: params.channel,
      page: params.page ?? 1,
      limit: params.limit ?? 25,
      status: params.status ?? "all",
    },
  });
  return response.data;
};

export const getCustomerCommunicationDetail = async (
  customerId: string,
  communicationId: number
): Promise<CustomerCommunicationDetail> => {
  const response = await axios.get(
    `${baseUrl(customerId)}/${communicationId}`
  );
  return response.data;
};
